import { gql } from "@apollo/client";

export const FETCH_COMPANY_SEATS = gql`
  query FetchCompanySeats {
    company {
      id
      name
      freePageQuota
      ownerId
      subscription {
        id
        seatsS
        seatsM
        seatsL
      }
      users {
        id
        name
        email
        title
        role
        size
        pageQuota
        usedPages
      }
      inviteLinks {
        id
        code
        email
        role
        size
        isUsed
        createdAt
      }
    }
  }
`; 